module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "material",
    attrs: {
      "id": "MATERIAL-SWF"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mask_visible),
      expression: "mask_visible"
    }],
    staticClass: "mask"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading && 0 == _vm.public_list_data.length),
      expression: "loading && 0 == public_list_data.length"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading",
    attrs: {
      "element-loading-text": "",
      "element-loading-background": "#3a3a3a"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "color": "white",
      "width": "100%",
      "height": "30px",
      "left": "0",
      "right": "0",
      "top": "55%",
      "margin": "auto",
      "text-align": "center",
      "position": "absolute",
      "line-height": "30px"
    }
  }, [_vm._v("数据加载中")])]), _vm._v(" "), _c('div', {
    staticClass: "tabs"
  }, _vm._l((_vm.tab_tab), function(item, index) {
    return _c('div', {
      class: {
        'active': item.active
      },
      on: {
        "click": function($event) {
          return _vm.handleTabChange(index)
        }
      }
    }, [_vm._v("\n      " + _vm._s(item.name.length > 6 ? item.name.substring(0, 6) + '...' : item.name) + "\n    ")])
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.theme_show),
      expression: "!theme_show"
    }],
    staticClass: "search"
  }, [_c('div', {
    staticClass: "search-inner"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search_key),
      expression: "search_key"
    }],
    staticClass: "text",
    attrs: {
      "type": "text",
      "placeholder": "请输入素材名称、版权方、标签"
    },
    domProps: {
      "value": (_vm.search_key)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        return _vm.handdleStartSearch($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search_key = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-search button",
    on: {
      "click": _vm.handdleStartSearch
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.search_key.length > 0),
      expression: "search_key.length > 0"
    }],
    staticClass: "el-icon-close button",
    on: {
      "click": _vm.handleCloseSearch
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "category-nav"
  }, _vm._l((_vm.tab_category), function(item, index) {
    return _c('span', {
      staticClass: "bottom",
      class: {
        'active': item.active
      }
    }, [_c('div', {
      class: {
        'active': item.active
      },
      on: {
        "click": function($event) {
          return _vm.handleCategoryChange(index)
        }
      }
    }, [_vm._v(_vm._s(item.name))])])
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.music_play_status && _vm.tab_category_init == 'bgm'),
      expression: "music_play_status && tab_category_init == 'bgm'"
    }],
    staticClass: "player"
  }, [_c('div', {
    staticClass: "box-music"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("已选:   " + _vm._s(_vm.bgm_title)), _c('i', {
    staticClass: "el-icon-close",
    on: {
      "click": _vm.handleBgmCancle
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "play_pause"
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.play_status),
      expression: "!play_status"
    }],
    staticClass: "icon-play",
    on: {
      "click": _vm.handleBgmPlay
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.play_status),
      expression: "play_status"
    }],
    staticClass: "icon-pause",
    on: {
      "click": _vm.handleBgmPause
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.volume == 0),
      expression: "volume == 0"
    }],
    staticClass: "icon-mute",
    staticStyle: {
      "font-size": "24px",
      "color": "#4a4a4a"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.volume > 0),
      expression: "volume > 0"
    }],
    staticClass: "icon-voice",
    staticStyle: {
      "font-size": "24px",
      "color": "#4a4a4a"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "volume_change"
  }, [_c('el-slider', {
    staticStyle: {
      "-webkit-transform": "scale(0.55)",
      "width": "270px",
      "left": "-60px",
      "position": "relative"
    },
    attrs: {
      "step": 1
    },
    on: {
      "change": _vm.handleVolumeChange
    },
    model: {
      value: (_vm.volume),
      callback: function($$v) {
        _vm.volume = $$v
      },
      expression: "volume"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "volume_show"
  }, [_vm._v(_vm._s(_vm.volume))])])]), _vm._v(" "), _c('audio', {
    attrs: {
      "id": "audio-bgm-material",
      "src": _vm.audio_player,
      "loop": ""
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.theme_show),
      expression: "!theme_show"
    }],
    staticClass: "public",
    class: {
      position_top: _vm.music_play_status && _vm.tab_category_init == 'bgm'
    }
  }, [_c('div', {
    staticClass: "breadcrumb clearfix"
  }, _vm._l((_vm.breadcrumb), function(item, index) {
    return _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.breadcrumb.length > 1),
        expression: "breadcrumb.length > 1"
      }],
      on: {
        "click": function($event) {
          return _vm.handleTargetNav(index, item.folder_id, '')
        }
      }
    }, [_vm._v(_vm._s('/ ' + item.name))])
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.search_status && _vm.tab_left_pancel.length != 1),
      expression: "!search_status && tab_left_pancel.length != 1"
    }],
    staticClass: "category-type"
  }, _vm._l((_vm.tab_left_pancel), function(item, index) {
    return _c('div', {
      class: {
        'active': item.active
      },
      on: {
        "click": function($event) {
          return _vm.handleLeftPancelChange(index)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.name))])])
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.no_result),
      expression: "!no_result"
    }],
    staticClass: "list-wrapper",
    class: _vm.hideLeft
  }, [(_vm.tab_left_pancel_init != 'bgc') ? _c('ul', {
    staticClass: "list clearfix"
  }, _vm._l((_vm.public_list_data), function(item, index) {
    return (this.tab_left_pancel_init = 'buy') ? _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.count != 0),
        expression: "item.count != 0"
      }],
      class: [_vm.tab_category_init == 'bgm' ? 'item-bgm' : 'item', _vm.publicList],
      on: {
        "mousedown": function($event) {
          return _vm.handlePublicItemDown(item, $event)
        },
        "mouseup": function($event) {
          return _vm.handlePublicItemUp(item, $event)
        }
      }
    }, [_c('div', {
      staticClass: "inner"
    }, [(_vm.tab_category_init == 'bgm') ? [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_c('div', {
      staticClass: "name"
    }, [_c('span', [_vm._v(_vm._s(item.title))]), (_vm.tab_tab_init == 'public') ? _c('span', {
      staticClass: "tips"
    }, [_vm._v("免费")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "desc",
      attrs: {
        "title": item.copyright
      }
    }, [_vm._v(_vm._s(item.copyright))])])] : [(item.type == 'folder' | item.type == 'package') ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.tab_category_init != 'material' && _vm.tab_category_init != 'prop'),
        expression: "tab_category_init != 'material' && tab_category_init != 'prop'"
      }],
      staticClass: "pic folder"
    }, [_c('img', {
      staticStyle: {
        "width": "100%",
        "height": "100%",
        "margin": "0 auto"
      },
      attrs: {
        "src": require("./material_scene_file.png")
      }
    })]) : _vm._e(), _vm._v(" "), (item.type == 'folder' | item.type == 'package') ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.tab_category_init == 'material' || _vm.tab_category_init == 'prop'),
        expression: "tab_category_init == 'material' || tab_category_init == 'prop'"
      }],
      staticClass: "pic folder"
    }, [_c('img', {
      staticStyle: {
        "width": "64px",
        "height": "60px",
        "padding": "0"
      },
      attrs: {
        "src": require("./material_person_file.png")
      }
    })]) : _vm._e(), _vm._v(" "), (item.type != 'folder' && item.type != 'package') ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.tab_category_init != 'scene' && _vm.tab_category_init != 'material' && _vm.tab_category_init != 'prop'),
        expression: "tab_category_init != 'scene' && tab_category_init != 'material' && tab_category_init != 'prop'"
      }],
      staticClass: "pic padding"
    }, [_c('img', {
      attrs: {
        "src": _vm.tab_tab_init === 'public' ? item.thumb : item.preview,
        "onerror": _vm.img_default
      }
    })]) : _vm._e(), _vm._v(" "), (item.type != 'folder' && item.type != 'package' && (_vm.tab_category_init == 'material' || _vm.tab_category_init == 'prop')) ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.tab_tab_init === 'public' ? item.thumb : item.preview),
        expression: "tab_tab_init === 'public' ? item.thumb : item.preview"
      }],
      staticClass: "pic padding"
    }, [_c('img', {
      attrs: {
        "src": _vm.tab_tab_init === 'public' ? item.thumb : item.preview,
        "onerror": _vm.img_default
      }
    })]) : _vm._e(), _vm._v(" "), (item.type != 'folder' && item.type != 'package' && (_vm.tab_category_init == 'material' || _vm.tab_category_init == 'prop')) ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!(_vm.tab_tab_init === 'public' ? item.thumb : item.preview)),
        expression: "!(tab_tab_init === 'public' ? item.thumb : item.preview)"
      }],
      staticClass: "pic padding"
    }, [_c('img', {
      staticStyle: {
        "width": "33px",
        "height": "30px",
        "margin": "0 auto"
      },
      attrs: {
        "src": require("./default_person.png")
      }
    })]) : _vm._e(), _vm._v(" "), (item.type != 'folder' && item.type != 'package') ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.tab_category_init == 'scene' && (_vm.tab_tab_init === 'public' ? item.thumb : item.preview)),
        expression: "tab_category_init == 'scene' && (tab_tab_init === 'public' ? item.thumb : item.preview)"
      }],
      staticClass: "pic"
    }, [_c('img', {
      attrs: {
        "src": _vm.tab_tab_init === 'public' ? item.thumb : item.preview,
        "onerror": _vm.img_default
      }
    })]) : _vm._e(), _vm._v(" "), (item.type != 'folder' && item.type != 'package') ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.tab_category_init == 'scene' && !(_vm.tab_tab_init === 'public' ? item.thumb : item.preview)),
        expression: "tab_category_init == 'scene' && !(tab_tab_init === 'public' ? item.thumb : item.preview)"
      }],
      staticClass: "pic"
    }, [_c('img', {
      attrs: {
        "src": require("./default_scene.png")
      }
    })]) : _vm._e(), _vm._v(" "), (item.type != 'folder' && item.type != 'package') ? _c('div', {
      staticClass: "text"
    }, [_c('div', {
      staticClass: "name",
      attrs: {
        "title": item.title
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), (item.type != 'folder' && item.type != 'package') ? _c('div', {
      staticClass: "desc",
      attrs: {
        "title": item.copyright
      }
    }, [_vm._v(_vm._s(item.copyright))]) : _vm._e(), _vm._v(" "), (_vm.tab_tab_init == 'public') ? _c('div', {
      staticClass: "tip"
    }, [_vm._v("免费")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (item.type == 'folder' || item.type == 'package') ? _c('div', {
      staticClass: "text",
      staticStyle: {
        "background": "#505050"
      }
    }, [_c('div', {
      staticClass: "name",
      staticStyle: {
        "color": "#e2e2e2"
      },
      attrs: {
        "title": item.title
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "desc"
    }, [_vm._v(" ")]), _vm._v(" "), (_vm.tab_tab_init == 'public') ? _c('div', {
      staticClass: "tip"
    }, [_vm._v("免费")]) : _vm._e()]) : _vm._e()]], 2)]) : _vm._e()
  }), 0) : _vm._e(), _vm._v(" "), (_vm.tab_left_pancel_init == 'bgc') ? _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.color_type),
      expression: "!color_type"
    }],
    staticStyle: {
      "margin": "0",
      "float": "right",
      "margin-right": "10px",
      "background": "#4a9f95",
      "color": "#fff"
    },
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.color_type = true
      }
    }
  }, [_vm._v("简易")]) : _vm._e(), _vm._v(" "), (_vm.tab_left_pancel_init == 'bgc') ? _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.color_type),
      expression: "color_type"
    }],
    staticStyle: {
      "margin": "0",
      "float": "right",
      "margin-right": "10px",
      "background": "#4a9f95",
      "color": "#fff"
    },
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.color_type = false
      }
    }
  }, [_vm._v("高级")]) : _vm._e(), _vm._v(" "), (_vm.tab_left_pancel_init == 'bgc') ? _c('ul', {
    staticClass: "list clearfix color",
    attrs: {
      "id": "color"
    }
  }, [_vm._l((_vm.colors), function(item) {
    return (_vm.color_type) ? _c('li', {
      style: ({
        background: item
      }),
      on: {
        "click": function($event) {
          return _vm.handleColorChange(item)
        }
      }
    }) : _vm._e()
  }), _vm._v(" "), (!_vm.color_type) ? _c('photoshop', {
    model: {
      value: (_vm.colors_a),
      callback: function($$v) {
        _vm.colors_a = $$v
      },
      expression: "colors_a"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.color_type) ? _c('el-button', {
    staticStyle: {
      "margin": "0",
      "float": "right",
      "margin-right": "10px",
      "background": "#4a9f95",
      "color": "#fff"
    },
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.colorSubmit()
      }
    }
  }, [_vm._v("确认")]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relation:width:100%",
      "height": "20px"
    }
  })], 1), _vm._v(" "), (!_vm.no_result) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tab_left_pancel_init != 'bgc'),
      expression: "tab_left_pancel_init != 'bgc'"
    }],
    staticClass: "loadMore"
  }, [_c('el-pagination', {
    staticClass: "pagination",
    attrs: {
      "small": "",
      "page-size": 20,
      "pager-count": 5,
      "layout": "prev, pager, next",
      "total": _vm.pagination_list_count
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.theme_show),
      expression: "theme_show"
    }],
    staticClass: "theme-detail"
  }, [_c('el-button', {
    staticStyle: {
      "color": "#666"
    },
    attrs: {
      "type": "text",
      "size": "mini",
      "icon": "el-icon-arrow-left"
    },
    on: {
      "click": function($event) {
        return _vm.handleGoBack()
      }
    }
  }, [_vm._v("上一页")]), _vm._v(" "), _c('el-collapse', {
    attrs: {
      "accordion": ""
    },
    model: {
      value: (_vm.activeNames),
      callback: function($$v) {
        _vm.activeNames = $$v
      },
      expression: "activeNames"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": '场景(' + _vm.theme.scene.length + ')',
      "name": "1"
    }
  }, [_c('div', {
    staticClass: "theme-item"
  }, [_c('div', {
    staticClass: "title1"
  }), _vm._v(" "), _vm._l((_vm.theme.scene), function(item, index) {
    return _c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          return _vm.handleThemeChangeDetail(item, 'scene')
        }
      }
    }, [_c('div', {
      staticClass: "inner"
    }, [(_vm.tab_tab_init === 'public' ? item.thumb : item.preview) ? _c('div', {
      staticClass: "pic"
    }, [_c('img', {
      attrs: {
        "src": _vm.tab_tab_init === 'public' ? item.thumb : item.preview,
        "onerror": _vm.img_default
      }
    })]) : _c('div', {
      staticClass: "pic"
    }, [_c('img', {
      attrs: {
        "src": require("./default_scene.png")
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_c('div', {
      staticClass: "name",
      attrs: {
        "title": item.title
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "desc",
      attrs: {
        "title": item.copyright
      }
    }, [_vm._v(_vm._s(item.copyright))]), _vm._v(" "), _c('div', {
      staticClass: "tip"
    }, [_vm._v("免费")])])])])
  })], 2)]), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "title": '形象(' + _vm.theme.material.length + ')',
      "name": "2"
    }
  }, [_c('div', {
    staticClass: "theme-item"
  }, _vm._l((_vm.theme.material), function(item, index) {
    return _c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          return _vm.handleThemeChangeDetail(item, 'material')
        }
      }
    }, [_c('div', {
      staticClass: "inner"
    }, [(_vm.tab_tab_init === 'public' ? item.thumb : item.preview) ? _c('div', {
      staticClass: "pic padding"
    }, [_c('img', {
      attrs: {
        "src": _vm.tab_tab_init === 'public' ? item.thumb : item.preview,
        "onerror": _vm.img_default
      }
    })]) : _c('div', {
      staticClass: "pic padding"
    }, [_c('img', {
      staticStyle: {
        "width": "33px",
        "height": "30px",
        "margin": "0 auto"
      },
      attrs: {
        "src": require("./default_person.png")
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_c('div', {
      staticClass: "name",
      attrs: {
        "title": item.title
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "desc",
      attrs: {
        "title": item.copyright
      }
    }, [_vm._v(_vm._s(item.copyright))]), _vm._v(" "), _c('div', {
      staticClass: "tip"
    }, [_vm._v("免费")])])])])
  }), 0)]), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "title": '道具(' + _vm.theme.prop.length + ')',
      "name": "3"
    }
  }, [_c('div', {
    staticClass: "theme-item"
  }, _vm._l((_vm.theme.prop), function(item, index) {
    return _c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          return _vm.handleThemeChangeDetail(item, 'prop')
        }
      }
    }, [_c('div', {
      staticClass: "inner"
    }, [(_vm.tab_tab_init === 'public' ? item.thumb : item.preview) ? _c('div', {
      staticClass: "pic padding"
    }, [_c('img', {
      attrs: {
        "src": _vm.tab_tab_init === 'public' ? item.thumb : item.preview,
        "onerror": _vm.img_default
      }
    })]) : _c('div', {
      staticClass: "pic padding"
    }, [_c('img', {
      staticStyle: {
        "width": "33px",
        "height": "30px",
        "margin": "0 auto"
      },
      attrs: {
        "src": require("./default_person.png")
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_c('div', {
      staticClass: "name",
      attrs: {
        "title": item.title
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "desc",
      attrs: {
        "title": item.copyright
      }
    }, [_vm._v(_vm._s(item.copyright))]), _vm._v(" "), _c('div', {
      staticClass: "tip"
    }, [_vm._v("免费")])])])])
  }), 0)])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.no_result),
      expression: "no_result"
    }],
    staticClass: "no_results"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "text",
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v("暂时还没有内容呦~^-^~")])]), _vm._v(" "), (_vm.platform == 'qt') ? _c('psocket', {
    attrs: {
      "attributes": _vm.attributes,
      "flashvars": _vm.flashvars
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pic"
  }, [_c('img', {
    attrs: {
      "src": require("../Bgm/music.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pic"
  }, [_c('img', {
    attrs: {
      "src": require("./no_result.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f8fcb06","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Material/Material.vue
// module id = 387
// module chunks = 0